import {
  UPDATE_ACCESS_TABLE,
  UPDATE_ADMINS_TABLE,
  UPDATE_BILLS_TABLE,
  UPDATE_COUNTERS_LIST,
  UPDATE_COUNTER_TYPES,
  UPDATE_PROFILE,
  UPDATE_PROJECTS_LIST,
  UPDATE_PROJECT_COUNTER_TYPES,
  UPDATE_USERS_LIST,
  UPDATE_PROJECT,
} from "../actions/Types";

const initialState = {
  updateProjectsList: false,
  updateUsersList: false,
  updateCounterTypes: false,
  updateCountersList: false,
  updateProfile: false,
  updateAccessTable: false,
  updateAdminsTable: false,
  updateBillsTable: false,
  updateProjectCounterTypes: false,
  updateProject: false,
};

const UpdateCommandsReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PROJECTS_LIST:
      return {
        ...state,
        updateProjectsList: action.payload.updateProjectsList,
      };
    case UPDATE_USERS_LIST:
      return { ...state, updateUsersList: action.payload.updateUsersList };
    case UPDATE_COUNTER_TYPES:
      return {
        ...state,
        updateCounterTypes: action.payload.updateCounterTypes,
      };
    case UPDATE_COUNTERS_LIST:
      return {
        ...state,
        updateCountersList: action.payload.updateCountersList,
      };
    case UPDATE_PROFILE:
      return {
        ...state,
        updateProfile: action.payload.updateProfile,
      };
    case UPDATE_ACCESS_TABLE:
      return {
        ...state,
        updateAccessTable: action.payload.updateAccessTable,
      };
    case UPDATE_ADMINS_TABLE:
      return {
        ...state,
        updateAdminsTable: action.payload.updateAdminsTable,
      };
    case UPDATE_BILLS_TABLE:
      return {
        ...state,
        updateBillsTable: action.payload.updateBillsTable,
      };
    case UPDATE_PROJECT_COUNTER_TYPES:
      return {
        ...state,
        updateProjectCounterTypes: action.payload.updateProjectCounterTypes,
      };
    case UPDATE_PROJECT:
      return {
        ...state,
        updateProject: action.payload.updateProject,
      };
    default:
      return state;
  }
};

export default UpdateCommandsReducer;
